module.exports = __webpack_public_path__ + "media/images/testing-page-thumbnail-9f61833a60e9ade1a498fb341e477b45.png";